module.exports = __webpack_public_path__ + "static/media/load2.dfbc34a2.gif";